import { render } from "./UserProfileBanner.vue?vue&type=template&id=4b67144c&scoped=true"
import script from "./UserProfileBanner.vue?vue&type=script&lang=ts"
export * from "./UserProfileBanner.vue?vue&type=script&lang=ts"

import "./UserProfileBanner.vue?vue&type=style&index=0&id=4b67144c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4b67144c"

export default script